import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Reservation } from '../../../types/Reservation';
import { dateOptions, formatDate, timeOptions } from '../../../utils/functions/formatDate';
import './ReservationHistoryPanel.css';

const statusLabel: Record<string, string> = {
  confirmed: 'Confirmada',
  in_progress: 'Procesando'
};

interface ReservationHistoryPanelProps {
  currentReservationId: string;
  history: Reservation[];
  isLoading: boolean;
}

const ReservationHistoryPanel: React.FC<ReservationHistoryPanelProps> = ({
  currentReservationId,
  history,
  isLoading
}) => {
  // Las reservas canceladas no cuentan como historial: la clase nunca se dio.
  const otherReservations = history.filter(
    (r) => r.external_id !== currentReservationId && r.status !== 'cancelled'
  );

  return (
    <div className="history-panel">
      <Typography
        variant="overline"
        sx={{ color: 'var(--gray-500)', fontWeight: 600, display: 'block', mb: 1 }}>
        Historial con este profe
      </Typography>

      {isLoading && (
        <Typography variant="body2" sx={{ color: 'var(--gray-500)' }}>
          Cargando...
        </Typography>
      )}

      {!isLoading && otherReservations.length === 0 && (
        <Typography variant="body2" sx={{ color: 'var(--gray-500)' }}>
          Esta es tu primera clase con este profe.
        </Typography>
      )}

      {!isLoading &&
        otherReservations.map((reservation) => (
          <Link
            key={reservation.external_id}
            to={`/reservations/${reservation.external_id}`}
            className="history-item">
            <Typography variant="body2" sx={{ color: 'var(--gray-900)', fontWeight: 500 }}>
              {formatDate(reservation.event.start, dateOptions)}
            </Typography>
            <Typography variant="caption" sx={{ color: 'var(--gray-500)', display: 'block' }}>
              {formatDate(reservation.event.start, timeOptions)} -{' '}
              {formatDate(reservation.event.end, timeOptions)}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color:
                  reservation.status === 'confirmed' ? 'var(--primary-green)' : 'var(--blue-200)'
              }}>
              {statusLabel[reservation.status] ?? reservation.status}
            </Typography>
          </Link>
        ))}
    </div>
  );
};

export default ReservationHistoryPanel;
